<app-gabarit-confirmation (systemesEnErreur)="onSystemesEnErreurChange($event)">
  <span class="dsd-t-4" confirmation-titre>
    {{ 'confirmation.adresse.titre' | translate }}
  </span>
  <span class="dsd-t-4" confirmation-titre-partiel>
    {{ 'confirmation.adresse.titrePartiel' | translate }}
  </span>
  <span confirmation-partiel-contexte>
    {{ 'confirmation.partiel.adresse' | translate }}
  </span>
  @if (afficherDGAG) {
    <div #steps>
      @if (afficherAppelDGAG) {
        <p id="dgag">{{ 'confirmation.etapes.appelerDGAG' | translate }}</p>
      } @else if (afficherRecevoirAppel) {
        <p id="dgag-no-contact">{{ 'confirmation.etapes.recevoirAppelDGAG' | translate }}</p>
      }
    </div>
  }
</app-gabarit-confirmation>
